<template>
<svg viewBox="-2 0 24 24" fill="none"
	stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
	<polygon points="5 3 19 12 5 21 5 3"></polygon>
</svg>
</template>
